export default __webpack_public_path__ + "static/media/third-party-data-consent-kr-2.bcbe4f07.jpg";